import { render, staticRenderFns } from "./ViewportMobile.vue?vue&type=template&id=2f13c026"
import script from "./ViewportMobile.vue?vue&type=script&lang=js"
export * from "./ViewportMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports